module.exports = __webpack_public_path__ + "c88c7598b115f92d8721bff3560daf15.jpg";